import { Identifiable, OrganizationalUnit } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type LinkedOrganizationalUnit = {
  uuid: string;
  name: string;
  rankKey: string;
  parentUuid: string | null;
};

function saveOrganizationalUnit(httpClient: HttpClient) {
  return (organizationalUnit: OrganizationalUnit) =>
    httpClient
      .sendHttpRequest<LinkedOrganizationalUnit>({
        endpoint: "/organizational-units",
        method: HttpMethods.POST,
        data: {
          name: organizationalUnit.name,
          parent: organizationalUnit.parentUuid
            ? `organizational-units/${organizationalUnit.parentUuid}`
            : null,
        },
      })
      .then(
        ({
          uuid,
          name,
          rankKey,
          parentUuid,
        }): Identifiable<OrganizationalUnit> => ({
          uuid,
          name,
          rankKey,
          parentUuid: parentUuid ?? undefined,
        }),
      )
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { saveOrganizationalUnit };
